import { gql, useQuery } from '@apollo/client';
import {
  FormControl,
  FormControlProps,
  FormLabel,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
} from '@chakra-ui/react';
import * as React from 'react';

import { SelectButton } from '@/components/SelectButton';

import {
  MembershipType_MembershipTypes,
  MembershipType_MembershipTypesVariables,
} from './graphql-types/MembershipType_MembershipTypes';

type MembershipTypeProps = {
  value: string[];
  onChange: (value: string[]) => void;
} & Omit<FormControlProps, 'value' | 'onChange'>;

const MEMBERSHIP_TYPES = gql`
  query MembershipType_MembershipTypes($input: MembershipTypesInput!) {
    membershipTypes(input: $input) {
      ... on MembershipTypesSuccess {
        results {
          _id
          name
        }
      }
    }
  }
`;

export const MembershipType: React.FC<MembershipTypeProps> = ({
  value,
  onChange,
  ...props
}) => {
  const query = useQuery<
    MembershipType_MembershipTypes,
    MembershipType_MembershipTypesVariables
  >(MEMBERSHIP_TYPES, {
    variables: {
      input: {
        limit: 100,
        offset: 0,
        filter: {
          isActive: true,
        },
      },
    },
  });

  return (
    <FormControl {...props}>
      <FormLabel textStyle="detailStrong">Membership Type</FormLabel>
      <Menu closeOnSelect={false}>
        <MenuButton as={SelectButton} variant="menu" whiteSpace="nowrap">
          {value.length === 0
            ? 'All'
            : value.length === 1
            ? value[0]
            : `(${value.length}) Selected`}
        </MenuButton>
        <MenuList>
          <MenuOptionGroup value={value} onChange={onChange} type="checkbox">
            {query.data?.membershipTypes.results.map((membershipType) => (
              <MenuItemOption
                key={membershipType.name}
                value={membershipType.name}
              >
                {membershipType.name}
              </MenuItemOption>
            ))}
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    </FormControl>
  );
};
